import * as sentry from './sentry';
import SentryComponent from './SentryComponent';

export { default as useSentry } from './useSentry';

export const provider = {
  getSentry: sentry.getSentry,
};

export const Component = SentryComponent;
